import React from 'react';
export function ParadoxicalQuestionsSection() {
  const questions = ['E se non fosse "colpa dell\'età", ma mancanza del giusto allenamento?', 'E se bastassero 10 minuti al giorno per ritrovare fiducia?', 'E se il vero "segreto" fosse la costanza, non la perfezione?'];
  return <section className="w-full bg-gradient-to-r from-green-50 to-blue-50 py-20 px-4 sm:px-6 lg:px-8" data-id="element-179">
      <div className="max-w-4xl mx-auto" data-id="element-180">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-12 text-center" data-id="element-181">
          Domande che cambiano prospettiva
        </h2>
        <div className="space-y-6" data-id="element-182">
          {questions.map((question, index) => <div key={index} className="bg-white p-6 sm:p-8 rounded-lg shadow-sm border-l-4 border-green-600" data-id="element-183">
              <p className="text-xl sm:text-2xl font-semibold text-gray-900" data-id="element-184">
                {question}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}